import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const formulasAdapter = createEntityAdapter();

const initialState = formulasAdapter.getInitialState({
	status: "idle",
	error: null,
});

const formulasSlice = createSlice({
	name: "formula",
	initialState,
	reducers: {
		formulaAdded(state, action) {
			formulasAdapter.addOne(state, action.payload);
		},
		formulaEdited(state, action) {
			formulasAdapter.upsertOne(state, action.payload);
		},
		formulasReceived(state, action) {
			formulasAdapter.setAll(state, action.payload);
		},
		formulasEdited(state, action) {
			formulasAdapter.upsertMany(state, action.payload);
		},
	},
});

export const { formulaAdded, formulaEdited, formulasReceived, formulasEdited } =
	formulasSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllFormulas, selectById: selectFormulaById } =
	formulasAdapter.getSelectors((state) => state.formulas);

export const selectFormulasError = (state) => state.formulas.error;

export default formulasSlice.reducer;
